import { createContext } from 'react';

const RoleAccessContext = createContext();

export default RoleAccessContext;